import React from 'react';

const TabManagerContext = React.createContext();

export default TabManagerContext;
